export * from './relations-list/relations-list.component';
export * from './relations-details/relations-details.component';